module.exports = __webpack_public_path__ + "media/images/icons/academy-bundle-1a5c6f3393f709d6ba5d9ecf2ef4f0f3.svg";